var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),(_vm.value.state == 'opt-out')?_c('p',[_vm._v(" You have been opted in to bulk messaging. ")]):_c('p',[_vm._v(" You have been opted out of bulk messaging. ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticStyle:{"text-align":"center","font-size":"16px"}},[_c('b',[_vm._v("Bulk Messaging")])])
}]

export { render, staticRenderFns }